import React from 'react';
import loadable from '@loadable/component';

const About = loadable(() => import('containers/About/About'));
const Accessibility = loadable(() => import('containers/About/Accessibility'));
const CareerDetails = loadable(() => import('containers/About/CareerDetails'));
const Careers = loadable(() => import('containers/About/Careers'));
const CommunityGuidelines = loadable(() => import('containers/About/CommunityGuidelines'));
const Team = loadable(() => import('containers/About/Team'));

export default () => ({
  path: '/about',

  indexRoute: {
    component: props => <About {...props} />,
  },

  childRoutes: [
    {
      path: 'community-standards',
      component: props => <CommunityGuidelines {...props} />,
    },
    { path: 'team', component: props => <Team {...props} /> },
    { path: 'accessibility', component: props => <Accessibility {...props} /> },
    { path: 'careers', component: props => <Careers {...props} /> },
    { path: 'careers/:jobId', component: props => <CareerDetails {...props} /> },
  ],
});
